module.exports = __webpack_public_path__ + "static/media/Spain.485d94a6.jpg";